import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Typography, TextField, Button, Box, Card, CardContent, Alert } from "@mui/material";
import MDEditor from "@uiw/react-md-editor";

import api from "../../api";

const AddCard = ({ token }) => {
    const { deckId } = useParams();
    const [title, setTitle] = useState("");
    const [body, setBody] = useState("");
    const [status, setStatus] = useState(null);
    const navigate = useNavigate();

    const handleSubmit = async () => {
        if (!title || !body) {
            setStatus({ type: "error", message: "Title and body are required!" });
            return;
        }

        try {
            const response = await api.post(`/decks/${deckId}/add-card`, {
                question: title,
                answer: body
            });

            if (response.status === 201) {
                setStatus({ type: "success", message: "Card added successfully!" });
                setTitle("");
                setBody("");
            } else {
                setStatus({ type: "error", message: "Failed to add card. Please try again." });
            }
        } catch (error) {
            console.error("Error adding card:", error);
            setStatus({ type: "error", message: "An error occurred. Please try again." });
        }
    };

    return (
        <Container sx={{ maxWidth: "80%", mt: 5 }}>
            <Typography variant="h4" gutterBottom>
                Add a New Card
            </Typography>

            {status && (
                <Box sx={{ mb: 2, p: 2, bgcolor: status.type === "success" ? "green.100" : "red.100", borderRadius: 1 }}>
                    <Typography variant="body1" color={status.type === "success" ? "green" : "red"}>
                        {status.message}
                    </Typography>
                </Box>
            )}

            <TextField
                fullWidth
                label="Title"
                variant="outlined"
                margin="normal"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
            />

            <Box sx={{ mt: 3 }}>
                <Typography variant="h6">Markdown Editor</Typography>
                <MDEditor value={body} onChange={setBody} height={200} />
            </Box>

            <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
                <Button variant="contained" color="primary" onClick={handleSubmit}>
                    Add Card
                </Button>
                <Button variant="outlined" color="secondary" onClick={() => navigate(`/decks/${deckId}`)}>
                    View Cards
                </Button>
            </Box>
        </Container>
    );
};

export default AddCard;
